export class WebSocketService {
  /**
   * @param {string} recipient
   * @param {string} clientId
   * @returns {Promise<void>}
   */
  static async closeConnectionFromRecipientAndClientId(recipient, cliendId) {
    try {
      const res = await brain.utils.ajaxMicroservice({
        method: 'DELETE',
        uri: `/v1/app/${brain.company.json.id}/recipient/${recipient}/websocket/${cliendId}/close`,
        microservice: 'notifications',
      });

      return [null, res];
    } catch (err) {
      return [err, null];
    }
  }
}
